module.exports = __webpack_public_path__ + "static/media/stamp_7.d4a145c0.png";